import React from 'react';
import { Link } from 'react-router-dom';
import { Video, BarChart3, Users, Settings, TrendingUp, BookOpen, Bell } from 'lucide-react';
import './AdminDashboard.css';

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard">
      <div className="admin-dashboard-header">
        <h1>Admin Dashboard</h1>
        <p>Manage your platform, users, and analytics</p>
      </div>

      <div className="admin-menu-grid">
        <Link to="/admin/webinars" className="admin-menu-card">
          <div className="admin-menu-icon" style={{ background: '#e3f2fd' }}>
            <Video size={32} style={{ color: '#1976d2' }} />
          </div>
          <h3>Manage Webinars</h3>
          <p>Create and manage live streaming sessions</p>
        </Link>

        <Link to="/admin/ai-usage" className="admin-menu-card">
          <div className="admin-menu-icon" style={{ background: '#e0f7f5' }}>
            <BarChart3 size={32} style={{ color: '#30C4B5' }} />
          </div>
          <h3>AI Usage Analytics</h3>
          <p>Monitor AI API usage, costs, and user activity</p>
        </Link>

        <Link to="/admin/users" className="admin-menu-card">
          <div className="admin-menu-icon" style={{ background: '#f3e5f5' }}>
            <Users size={32} style={{ color: '#9c27b0' }} />
          </div>
          <h3>User Management</h3>
          <p>Manage user subscriptions and tier upgrades</p>
        </Link>

        <Link to="/admin/templates" className="admin-menu-card">
          <div className="admin-menu-icon" style={{ background: '#e0f7f5' }}>
            <BookOpen size={32} style={{ color: '#14b8a6' }} />
          </div>
          <h3>Manage Templates</h3>
          <p>Create & organize code templates for users</p>
        </Link>

        <Link to="/admin/notifications" className="admin-menu-card">
          <div className="admin-menu-icon" style={{ background: '#fff3e0' }}>
            <Bell size={32} style={{ color: '#f57c00' }} />
          </div>
          <h3>Notifications</h3>
          <p>Send notifications to users across the platform</p>
        </Link>

        <Link to="/admin/analytics" className="admin-menu-card">
          <div className="admin-menu-icon" style={{ background: '#fff3e0' }}>
            <TrendingUp size={32} style={{ color: '#f57c00' }} />
          </div>
          <h3>Analytics</h3>
          <p>Platform analytics and insights</p>
        </Link>

        <div className="admin-menu-card admin-menu-card-disabled">
          <div className="admin-menu-icon" style={{ background: '#f1f3f5' }}>
            <Settings size={32} style={{ color: '#495057' }} />
          </div>
          <h3>System Settings</h3>
          <p>Configure platform settings</p>
          <span className="coming-soon">Coming Soon</span>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
